import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { NormalizedFieldState, NormalizedUIField } from '../../../store/config.models';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { ButtonDisableIdentifier } from '../../../store/models/validator-identifier';
import * as fromSelectors from '../../../store/selectors';
import { FieldType } from '../../../store/models/field-models';
import { UIElementType } from '../../../store/models';

@Component({
    selector: 'app-menu-element',
    templateUrl: './menu-element.component.html',
    styleUrls: ['./menu-element.component.scss'],
})
export class MenuElementComponent implements OnInit {
    @Input() field: NormalizedUIField;
    @Input() control: FormGroup | FormControl;
    @Input() isReadOnly = false;

    isMenuOpen = false;
    isDisabled$: Observable<boolean> = of(false);

    FieldType = FieldType;
    UIElementType = UIElementType;

    constructor(private store: Store, private translate: TranslateService) {}

    ngOnInit(): void {
        if (this.isReadOnly) {
            this.isDisabled$ = of(true);
            return;
        }

        if (this.field.disabledSelector) {
            switch (this.field.disabledSelector) {
                case ButtonDisableIdentifier.invalidOrPristine:
                    this.isDisabled$ = this.store.select(fromSelectors.selectFormInvalidOrPristine);
                    break;
                case ButtonDisableIdentifier.invalid:
                    this.isDisabled$ = this.store.select(fromSelectors.selectFormInvalid);
                    break;
                case ButtonDisableIdentifier.pristine:
                    this.isDisabled$ = this.store.select(fromSelectors.selectFormPristine);
                    break;
                case ButtonDisableIdentifier.invalidOrUnsaved:
                    this.isDisabled$ = this.store.select(fromSelectors.selectFormInvalidOrUnsaved);
                    break;
                default:
                    this.isDisabled$ = of(!!this.field.disabled);
            }
        } else {
            this.isDisabled$ = of(!!this.field.disabled);
        }
    }

    get isVisible(): boolean {
        return this.field?.visible !== false;
    }

    /**
     * Toggle menu open/closed state
     */
    toggleMenu(event: Event): void {
        if (this.isReadOnly || this.field.disabled) {
            return;
        }

        this.isMenuOpen = !this.isMenuOpen;
        event.stopPropagation();
    }

    /**
     * Closes the menu
     */
    closeMenu(): void {
        this.isMenuOpen = false;
    }

    /**
     * Gets the control for a specific menu item when it's a form field
     */
    getControlForMenuItem(menuItem: NormalizedFieldState): FormControl | null {
        if (!this.control || menuItem.type === FieldType.UI || menuItem.type === FieldType.Section) {
            return null;
        }

        return this.control.get(menuItem.id) as FormControl;
    }
}
